import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BackendErrorLoggerService } from './backend/backend-error-logger.service';
import { Problem } from '../../api';
import { Store } from '@ngrx/store';
import { changeVisibilityOfBackendError } from '../../states/app/app.actions';

@Injectable({
  providedIn: 'root',
})
export class ErrorDispatcherService {
  constructor(
    private backendErrorLoggerService: BackendErrorLoggerService,
    private store: Store,
  ) {}

  public handleError(error: Error): void {
    if (ErrorDispatcherService.isBackendProblemError(error)) {
      // Don't log errors from our backend, as it has already been logged there
      return;
    }

    if (ErrorDispatcherService.isBackendRequestError(error)) {
      this.store.dispatch(
        changeVisibilityOfBackendError({
          showBackendErrorPopup: true,
        }),
      );
    }

    this.logFrontendError(error);
  }

  private static isBackendRequestError(error: Error): boolean {
    if (error instanceof HttpErrorResponse) {
      const isBackendRequestError = error.url?.includes('/offer/api/public');
      return isBackendRequestError ?? false;
    }

    return false;
  }

  private static isBackendProblemError(error: Error): boolean {
    if (error instanceof HttpErrorResponse) {
      return ((error as HttpErrorResponse).error as Problem).detail !== undefined;
    }
    return false;
  }

  private logFrontendError(error: Error): void {
    const stacktrace = error.stack || '';
    this.backendErrorLoggerService.log$(error.name, error.message, stacktrace).subscribe({
      error: () => {}, // prevent recursive error logging
    });
  }
}
